// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import {
    chain,
    RequestDataFromApi,
    SetEmptyData,
} from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ProductInventoryDto, RealTimeInventoryModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Parameters<typeof RequestDataFromApi>[0];

export const SetCallRealTimeFlag = (props: HandlerType) => {
    (props.parameter as any).callService = true;
    const session = getSession(props.getState());
    const isAutenticated = session.isAuthenticated || session.rememberMe;
    if (!isAutenticated) {
        const hasEvents = props.parameter?.productIds?.some(
            productId =>
                getProductState(props.getState(), productId).value?.properties.isEvent?.toLowerCase() === "true",
        );
        if (!hasEvents) {
            (props.parameter as any).callService = false;
        }
    }
};

export const CustomSetEmptyData = (props: HandlerType) => {
    if (
        getSettingsCollection(props.getState()).productSettings.showInventoryAvailability &&
        (props.parameter as any).callService
    ) {
        return;
    }

    const { isAuthenticated } = props.getState().context.session;

    props.apiResult = {
        realTimeInventoryResults: props.apiParameter.productIds.map(o => {
            const uoms = getProductState(props.getState(), o).value?.unitOfMeasures?.map(p => p.unitOfMeasure) ?? [""];
            return {
                productId: o,
                inventoryAvailabilityDtos: uoms?.map(uom => {
                    return {
                        availability: {
                            message: isAuthenticated ? "" : siteMessage("Inventory_SignInForAvailability"),
                            messageType: isAuthenticated ? 0 : 1,
                            requiresRealTimeInventory: false,
                        },
                        unitOfMeasure: uom,
                    };
                }),
            } as ProductInventoryDto;
        }),
    } as RealTimeInventoryModel;
};

export const CustomRequestDataFromApi = (props: HandlerType) => {
    if (!(props.parameter as any).callService) {
        return;
    }
    return RequestDataFromApi(props);
};

addToChainBefore(chain, SetEmptyData, SetCallRealTimeFlag);
replaceInChain(chain, SetEmptyData, CustomSetEmptyData);
replaceInChain(chain, RequestDataFromApi, CustomRequestDataFromApi);
